<button mat-icon-button (click)="openUtilisationInterval($event)">
  <mat-icon>poll</mat-icon>
</button>
